import React, { useCallback } from "react";
import styles from "./text-input.module.scss";
import textInputStyles from "../../BaseElements/TextInput/text-input.module.scss";
import classnames from "classnames";
import { Field, FieldProps, useFormikContext } from "formik";
import { observer } from "mobx-react-lite";
import type { FormTextInputProps } from "@whatslly/types/UI-V2/FormElements/FormTextInputType";
import { Label } from "../../BaseElements/Label";
import globalStyles from "../../globalStyles";
import { FormFieldV2 } from "../FormField";

export const FormPasswordTextInput: React.FC<FormTextInputProps> = observer(
  ({
    labelText,
    labelFontSize,
    labelFontWeight,
    labelColor,
    labelUnderLine,
    labelInline,
    paddingInline,
    marginBottom,
    marginTop,
    labelComment,
    className,
    onChange,
    name,
    required,
    placeholder,
    disabled,
    ...props
  }) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const formikContext = useFormikContext<Record<string, any>>();
    const formOnChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        formikContext.handleChange(e);
        if (onChange) {
          return onChange(e);
        }
      },
      [formikContext, onChange]
    );

    return (
      <FormFieldV2
        className={classnames(
          styles.inputContainer,
          globalStyles[`pi-${paddingInline ?? "default"}`],
          globalStyles[`d-${labelInline ? "flex" : ""}`],
          globalStyles[`flex-${labelInline ? "row" : ""}`],
          globalStyles[`mt-${marginTop}`],
          globalStyles[`mb-${marginBottom ?? "default"}`],
          globalStyles[`align-items-${labelInline ? "center" : ""}`],
          globalStyles[`justify-content-${labelInline ? "between" : ""}`]
        )}
        errorText={formikContext.errors[name] as string}
        showError={!!formikContext.errors[name] && !!formikContext.touched[name]}
      >
        {labelText && (
          <Label
            text={labelText}
            fontSize={labelFontSize}
            color={labelColor}
            marginBottom={labelInline ? "none" : "small"}
            underLine={labelUnderLine}
            comment={labelComment}
            fontWeight={labelFontWeight}
            required={required}
          />
        )}
        <Field
          placeholder={placeholder}
          name={name}
          children={(fieldData: FieldProps) => {
            return (
              <div
                className={classnames(
                  textInputStyles.inputContainer,
                  globalStyles[`pi-none`],
                  globalStyles[`mb-none`],
                  globalStyles[`fs-default`],
                  globalStyles[`mt-none`]
                )}
              >
                <input
                  required={required}
                  name={name}
                  type={"password"}
                  placeholder={placeholder}
                  onChange={(e) => fieldData.form.handleChange(e)}
                  disabled={disabled}
                  className={classnames(
                    textInputStyles.textInput,
                    globalStyles[`br-default`],
                    globalStyles[`fs-default`],
                    globalStyles[`fw-default`],
                    globalStyles[`input-${props.inputSize ?? "default"}`],
                    globalStyles[`bg-color-${disabled ? "disabled-input" : "main-secondary"}`],
                    globalStyles[`color-main-primary`],
                    globalStyles[`bc-neutral-secondary`],
                    globalStyles[`outline-neutral-primary`],
                    globalStyles[`outline-width-default`],
                    globalStyles[`v2ElementContainer`]
                  )}
                />
              </div>
            );
          }}
          className={classnames(
            {
              [styles.inlineLabel]: labelInline,
            },
            className
          )}
        />
      </FormFieldV2>
    );
  }
);
